import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExampleHeader, TargetDatesComponent } from './target-dates.component';
import { BaseModule } from 'src/app/core/base/base.module';
import { PrimaryButtonModule } from 'src/app/shared/micro-components/primary-button/primary-button.module';
import { MaterialModule } from 'src/app/core/material/material.module';
import { FlexLayoutModule, FlexModule } from '@angular/flex-layout';
import { SaCardModule } from 'src/app/components/sa-card/sa-card.module';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { PageHeaderModule } from 'src/app/shared/components/page-header/page-header.module';
import { ContentCardModule } from 'src/app/shared/components/content-card/content-card.module';



@NgModule({
  declarations: [
    TargetDatesComponent,
    ExampleHeader
  ],
  imports: [
    CommonModule,
    BaseModule,
    PrimaryButtonModule,
    MaterialModule,
    FlexLayoutModule,
    FlexModule,
    SaCardModule,
    MatIconModule,
    MatDividerModule,
    PageHeaderModule,
    ContentCardModule,
    
  ],
  bootstrap: [TargetDatesComponent],
  exports: [
    TargetDatesComponent
  ]
})
export class TargetDatesModule { }
